import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { Table } from '../../../design-system';
import clientAPI from '../../../service/ApiServiceClientPortal';

const BRAND_BLACK = '#1B1B1B';

const styles = {
    title: {
        fontSize: 22,
        fontWeight: 600,
        color: BRAND_BLACK,
        margin: '0 0 24px 0',
    },
};

const columns = [
    {
        title: 'Company Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => <span style={{ fontWeight: 500, color: BRAND_BLACK }}>{text}</span>,
    },
    {
        title: 'Industry',
        dataIndex: 'industry',
        key: 'industry',
        render: (text) => text || '-',
    },
    {
        title: 'Projects',
        dataIndex: 'projectCount',
        key: 'projectCount',
        align: 'center',
        render: (val) => val ?? 0,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => {
            if (!status) return '-';
            return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        },
    },
];

const ClientCompanyList = () => {
    const navigate = useNavigate();
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCompanies = async () => {
            setLoading(true);
            try {
                const response = await clientAPI.get('/client-portal/companies');
                const data = response.data?.data || response.data;
                setCompanies(data.companies || data.items || data || []);
            } catch (err) {
                message.error('Failed to load companies');
            } finally {
                setLoading(false);
            }
        };
        fetchCompanies();
    }, []);

    const onRowClick = (record) => ({
        onClick: () => navigate(`/client-section/company/${record.id}`),
        style: { cursor: 'pointer' },
    });

    return (
        <div>
            <h1 style={styles.title}>My Company</h1>

            <Table
                columns={columns}
                dataSource={companies}
                variant="bordered"
                rowKey="id"
                loading={loading}
                onRow={onRowClick}
                pagination={false}
            />
        </div>
    );
};

export default ClientCompanyList;
